import * as React from 'react';
import styled from 'styled-components';
import ActionButton from './ActionButton';
import { ButtonIcon } from './ButtonIcon';
import { ColorPicker } from './ColorPicker';

const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

interface Props {
  color: string | string[];
  onChange: (index: number, color: string) => void;
  addColor: () => void;
  removeColor: (index: number) => void;
  compact: boolean;
}

export const MultiColorRow: React.FunctionComponent<Props> = props => {
  let colors: string[] = [];
  if (Array.isArray(props.color)) {
    colors = props.color;
  } else {
    colors = [props.color];
  }
  return (
    <div className="custom-property multi-color">
      <label>Color</label>
      <div>
        {colors.map((c, index) => {
          return (
            <RowWrapper key={index}>
              <ColorPicker
                color={c}
                onChange={newColor => props.onChange(index, newColor)}
                compact={props.compact}
              />
              {colors.length > 1 && (
                <ButtonIcon
                  icon="delete-color"
                  onClick={() => props.removeColor(index)}
                  iconSize={16}
                />
              )}
            </RowWrapper>
          );
        })}
        <div style={{ paddingLeft: 5 }}>
          <ActionButton onClick={props.addColor}>Add color</ActionButton>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controller/components/MultiColorRow.tsx